





















































































import {
  Vue, Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';
import RuleService from '@/domain/rule/service/rule.service';
import ItemRuleAliasSummary from '@/domain/rule/entity/item-rule-alias-summary.entity';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';

@Component({ components: { ModalComponent, LabelSlot } })

export default class AliasModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  businessUnitId!: string;

  @Prop() isAdministrator!: boolean;

  @Emit('cancel')
  private cancel(): void {}

  validationRules: Rules = new Rules();

  valid: boolean = false;

  itemRuleAlias: ItemRuleAliasSummary[] = [];

  selectItems: any[] = [];

  selectedRule: ItemRuleAliasSummary = ItemRuleAliasSummary.of({});

  ref: any = this.$refs.ref;

  created() {
    if (this.businessUnitId) {
      this.getContractItemAlias()
    }
  }

  @Watch('businessUnitId')
  getContractItemAlias() {
    if (this.$route.params.id) {
      RuleService.getContractItemRuleAlias(this.businessUnitId, this.$route.params.id)
        .then((response: any) => {
          this.itemRuleAlias = ItemRuleAliasSummary.ofList(response)
          this.selectItems = this.itemRuleAlias.map(this.buildItemRule)
        })
    }
  }

  selectRule(rule: any) {
    this.selectedRule = ItemRuleAliasSummary.of(
      this.itemRuleAlias.find((el: ItemRuleAliasSummary) => el.itemRuleId === rule.itemRuleId),
    );
  }

  buildItemRule(rule: ItemRuleAliasSummary): object {
    return {
      itemRuleId: rule.itemRuleId,
      name: rule.alias,
    }
  }

  saveRuleAlias() {
    if (this.valid) {
      RuleService.saveItemRuleAlias(this.businessUnitId, this.$route.params.id, this.selectedRule)
        .then((response: any) => {
          VbSnackbarService.showSuccess('Configuração salva com sucesso')
          this.getContractItemAlias();
          this.selectedRule = ItemRuleAliasSummary.of({});
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err))
    }
  }

  get options(): ModalOptions {
    return {
      title: 'Personalização de Regras',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 1280,
      persistent: true,
      disabledOk: !this.valid,
    }
  }
}

